import * as React from 'react';
import { Avatar, Layout, Col } from 'antd';

export default class TopBar extends React.Component {
  render() {
    return (
      <Layout className="top-bar">
        <Col offset={23}>
          <Avatar icon="user" />
        </Col>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/TopBar.tsx